import { GuiasService } from './../../services/guias/guias.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl} from '@angular/forms';
import { EmpresasService } from '../../services/empresas/empresas.service';
import { SafeUrlPipe } from '../../pipes/safe-url.pipe';
import Swal from "sweetalert2";
import {HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesGeneral, MessagesStatus } from '../../models/messages';


@Component({
  selector: 'app-adjuntar-archivo-empresa',
  templateUrl: './adjuntar-archivo-empresa.component.html',
  styleUrls: ['./adjuntar-archivo-empresa.component.scss'],
  providers:[
    SafeUrlPipe,MessagesTitles,MessagesGeneral,MessagesStatus
  ]
})
export class AdjuntarArchivoEmpresaComponent implements OnInit {

  @Input() dataEmpresa : any=[];
  @Output() cerrarPopUp: EventEmitter<boolean>;
  form : FormGroup;
  user:any;
  files: any[] = [];
  dataEnviar:any={};
  filesB64 :any;
  cantItems:number;
  arrayRepetidos: any = [];
  arrayAdjuntos:any = [];
  loading:boolean;
  view:boolean;

  Codigo:any= 1;
  TipoAdjunto:any = [];
  CantItemsSelect:number;

  constructor(private msgTitle :MessagesTitles,
              private msgStatus:MessagesStatus,
              private empresasService : EmpresasService,
              private guiasService:GuiasService) {

    this.guiasService.TipoAdjunto.subscribe(
      response => {
        console.log(response);
        this.TipoAdjunto= response; 
        this.TipoAdjunto =  this.TipoAdjunto.filter(
          state => state.Codigo == this.Codigo
        );
      this.CantItemsSelect = this.TipoAdjunto.length 
      });            

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.cerrarPopUp = new EventEmitter();
               }

  ngOnInit() {
    this.obtenerAdjuntosEmpresa(this.dataEmpresa.idEmpresa);
    this.form = new FormGroup({
      idEmpresa : new FormControl({ value: "", disabled: true }),
      idContacto : new FormControl({ value: "", disabled: true }),
      TipoAdjunto : new FormControl({ value: "", disabled: true }),
      file_content : new FormControl({ disabled: true }),
      Usuario : new FormControl({ value: "", disabled: true }),
      Razon_Social : new FormControl({ value: "", disabled: true }),
      Num_Doc_Identificacion : new FormControl({ value: "", disabled: true }),
      file_empresa : new FormControl({ value: "", disabled: false }),
      Estado : new FormControl({ value: "", disabled: true }),
    })

    this.form.controls['Razon_Social'].setValue(this.dataEmpresa.Razon_Social);
    this.form.controls['Num_Doc_Identificacion'].setValue(this.dataEmpresa.Num_Doc_Identificacion);
    this.form.controls['Estado'].setValue(this.dataEmpresa.Estado);
  }

  tipoAdjunto(event,i){
        this.files[i].Tipo_Adjunto = event
  }

  obtenerAdjuntosEmpresa(idEmpresa:any){
    this.loading = true;
    this.empresasService.obtenerAdjuntosEmpresa(idEmpresa).subscribe( 
      resp => {
        this.loading = false;
        this.arrayAdjuntos = resp;
      },(err: HttpErrorResponse)=> {
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event"); 
          this.msgStatus.getMessage(err.status); 
      } else {
          this.msgStatus.getMessage(err.status);            
      }
    Swal.fire({
      title: this.msgTitle.Error,
      text: "ADJUNTOS NO OBTENIDO. "+this.msgStatus.message,
      type: "error",
      allowOutsideClick: false,
      heightAuto: false
    });
    });
  }

  Guardar(){
    this.arrayRepetidos = [];
    this.cantItems = this.files.length - 1;
     let i = 0;
     this.dataEnviar.idEmpresa = this.dataEmpresa.idEmpresa;
     this.dataEnviar.Usuario = this.user.Usuario;
     this.dataEnviar.Alta_Canal = 'W'; 
     this.dataEnviar.Archivos = [];
     for( let p of this.files){
       
        if(p.type != 'application/pdf'){
          Swal.fire({
            title: this.msgTitle.Error,
            text: 'El archivo '+ p.name+ ' no es pdf',
            type: "warning",
            allowOutsideClick: false,
            heightAuto: false
          });
         return;
       }

       if(p.Tipo_Adjunto == undefined){
        Swal.fire({
          title: this.msgTitle.Error,
          text: 'Seleccione tipo de documento adjunto',
          type: "warning",
          allowOutsideClick: false,
          heightAuto: false
        });
         return;
       }

      this.aBinario(this.files,i)
      i++;
        
        }
    
  }

  aBinario(fileList: any ,index:any){
    let file = fileList[index];
    let fileReader: FileReader = new FileReader();
    var base64;
    var archivo64;
    var self = this;
    fileReader.onload =  function(fileLoadedEvent) {
              base64 = fileLoadedEvent.target['result'];
              archivo64 = base64.split(',',2);
              self.filesB64 = archivo64[1];
              self.dataEnviar.Archivos.push(
                {
                'file_type' : file.type,
                'file_name' : file.name,
                'file_content': self.filesB64,
                'Tipo_Adjunto': file.Tipo_Adjunto,
                'Origen': 'Empresas'
               }
              );  
              if(self.cantItems == index){
                self.Enviar(self.dataEnviar)
              }
           };
           
    fileReader.readAsDataURL(file);
  
  }

  Enviar(dataEnviar:any){
    Swal.fire({
      title: "Espere",
      text: "Guardando Archivos",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();
    
    this.empresasService.agregarAdjuntoDinamico(dataEnviar)
    .subscribe(
      res=>{
        Swal.fire({
          title: "Success",
          text: "Archivo registrado correctamente",
          type: "success",
          allowOutsideClick: false,
          heightAuto: false
        }).then(resp => {
          if (resp.value){
            this.obtenerAdjuntosEmpresa(this.dataEmpresa.idEmpresa);
            this.files = [];
          }
        });
      },(err: HttpErrorResponse)=> {
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event"); 
          this.msgStatus.getMessage(err.status);
        } else {
            this.msgStatus.getMessage(err.status);            
        }

        Swal.fire({
          title: this.msgTitle.Error,
          text: "ARCHIVO NO GUARDADO. "+this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );
  }

  darBajaAdjuntoDinamico(idAdjunto){
    Swal.fire({
        title:'',
        text:'¿Estás seguro en dar de baja el adjunto?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText:'Si,dar de baja.',
        cancelButtonText: 'No,Cancelar.',
        reverseButtons: true,
        heightAuto: false
    }).then((result)=>{
        if(result.value){
          Swal.fire({
            title: '¡Espere!',
            html: 'Procesando.'
          })
          Swal.showLoading();
          this.form = new FormGroup({
            'idAdjunto' : new FormControl(idAdjunto),
            'Estado' : new FormControl('B'),
            'Usuario': new FormControl(this.user.Usuario) 
          })
            
            this.empresasService.bajaAdjuntoDinamico(this.form.getRawValue())
            .subscribe(res=>{
              Swal.fire({
                title: '¡Adjunto dado de baja',
                text: 'El Adjunto fue dado de baja exitosamente.',
                type: 'success',
                heightAuto: false
              }).then(resp =>{
                if(resp.value == true){
                  this.obtenerAdjuntosEmpresa(this.dataEmpresa.idEmpresa);
                }
              });
            },
            err => {
              Swal.fire({
                title: "Error",
                text: "No se pudo dar de baja el adjunto.",
                type: "error",
                allowOutsideClick: false,
                heightAuto: false
              });
            })
        }
    })
} 



  /**
   * on file drop handler
   */
  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 20);
      }
    }, 100);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {

    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    this.uploadFilesSimulator(0);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  CerrarVentana(){
    this.cerrarPopUp.emit();
  }

}
